export default __webpack_public_path__ + "static/media/orders.404d15f2.png";